import { ArrowRight, BellRing, CheckCircle2, ExternalLink, WalletCards } from 'lucide-react'
import { useState } from 'react'
import EligibilityChecker from '../components/EligibilityChecker'
import SourceStamp from '../components/SourceStamp'
import { getDeadlineState } from '../lib/deadline'
import type { ProgramContent } from '../types/content'

interface HomeViewProps {
  program: ProgramContent
  onOpenPrepare: () => void
  onOpenSettings: () => void
}

export default function HomeView({ program, onOpenPrepare, onOpenSettings }: HomeViewProps) {
  const [checking, setChecking] = useState(false)

  if (checking) {
    return (
      <EligibilityChecker
        onClose={() => setChecking(false)}
        onOpenPrepare={onOpenPrepare}
        officialUrl={program.applicationUrl}
      />
    )
  }

  const deadline = getDeadlineState(program.application)

  return (
    <div className="view-stack">
      <section className={`status-hero status-hero--${deadline.tone}`}>
        <p className="eyebrow">{new Date().getFullYear()}년 {program.application.currentQuarter}분기</p>
        <h2>{deadline.label}</h2>
        <p>{deadline.detail}</p>
      </section>

      <section aria-labelledby="summary-title">
        <div className="section-heading">
          <div>
            <p className="eyebrow">핵심 정보</p>
            <h2 id="summary-title">한눈에 확인하세요</h2>
          </div>
        </div>
        <div className="summary-grid">
          <article className="summary-card">
            <WalletCards aria-hidden="true" />
            <span>지원 한도</span>
            <strong>연 {program.benefit.annualMaximumWon / 10000}만 원</strong>
            <small>분기별 {program.benefit.quarterlyMaximumWon / 10000}만 원</small>
          </article>
          <article className="summary-card">
            <CheckCircle2 aria-hidden="true" />
            <span>지원 대상</span>
            <strong>만 {program.eligibility.minimumAge}~{program.eligibility.maximumAge}세</strong>
            <small>신청일 기준 경기도 거주</small>
          </article>
        </div>
      </section>

      <section className="action-card">
        <div className="action-card__icon"><CheckCircle2 aria-hidden="true" /></div>
        <div>
          <p className="eyebrow">2분 자가진단</p>
          <h2>우리 아이도 해당될까요?</h2>
          <p>네 가지 질문으로 지원 가능성을 먼저 확인해 보세요.</p>
        </div>
        <button type="button" className="button button--primary" onClick={() => setChecking(true)}>
          자가진단 시작
          <ArrowRight aria-hidden="true" size={18} />
        </button>
      </section>

      <div className="quick-actions">
        <button type="button" className="quick-action" onClick={onOpenPrepare}>
          <CheckCircle2 aria-hidden="true" />
          <span><strong>신청 준비</strong><small>체크리스트 관리</small></span>
        </button>
        <button type="button" className="quick-action" onClick={onOpenSettings}>
          <BellRing aria-hidden="true" />
          <span><strong>마감 알림</strong><small>알림 설정하기</small></span>
        </button>
      </div>

      <a className="button button--official" href={program.applicationUrl} target="_blank" rel="noreferrer">
        공식 사이트에서 신청하기
        <ExternalLink aria-hidden="true" size={18} />
      </a>

      <SourceStamp sourceName={program.sourceName} sourceUrl={program.sourceUrl} lastVerifiedAt={program.lastVerifiedAt} />
    </div>
  )
}
